import type { AppearanceComponent, Slice } from '@setplex/tria-api'
import type {
  ComponentsPage,
  StructureOrigin,
  TGetComponentsFx,
} from '~/widgets/DynamicModule/model'

import { api } from '@setplex/tria-api'
import { createEffect } from 'effector'
import { logger } from '~/shared/logger'
import { filterRowsVisibility } from '~/widgets/DynamicModule/model/components/lib'
import { APPEARANCE_DEFAULT_HOME_ROWS } from './defaults'

export const getHomeRowsFx = createEffect(
  async ({ source, params }: TGetComponentsFx): Promise<ComponentsPage> => {
    let page: Slice<AppearanceComponent>
    let structureOrigin: StructureOrigin = 'backend'

    const grab = {
      enabled: async () => api.appearance.getModuleComponentsFx(params),
      disabled: async () => APPEARANCE_DEFAULT_HOME_ROWS(),
      fallback: async () => APPEARANCE_DEFAULT_HOME_ROWS(true),
    }

    // if `appearanceCustomizationEnabled` is not defined - this is old wbs, use fallback
    if (source.features.appearanceCustomizationEnabled == null) {
      page = await grab.fallback()
      structureOrigin = 'client'
    }

    // if `appearanceCustomizationEnabled` is enabled - load rows from the server
    else if (source.features.appearanceCustomizationEnabled) {
      try {
        page = await grab.enabled()
        structureOrigin = 'backend'
        // rows from dynamicModules already filtered
        // return rows
      } catch (error) {
        logger.error('Failed to load home rows:', error)

        // if this is the very first request - try to use default rows configuration as a fallback
        if (params == null || params.page === 0) {
          page = await grab.disabled()
          structureOrigin = 'client'
        } else {
          throw error
        }
      }
    }

    // if `appearanceCustomizationEnabled` is disabled - use default rows configuration
    else {
      page = await grab.disabled()
      structureOrigin = 'client'
    }

    const components: ComponentsPage = {
      ...page,
      structureOrigin,
    }

    components.content = filterRowsVisibility(components, source)

    return components
  }
)
